export function uniqueFilterFn(
    value: any,
    index: number,
    self: any[],
    property: string,
): any {
    const current = self.find((x) => x[property] === value[property]);
    return self.indexOf(current) === index;
}

export function sortFn(
    a: any,
    b: any,
    property: string,
    dir: 'asc' | 'desc' = 'asc',
): number {
    if (a[property] > b[property]) {
        return dir === 'asc' ? 1 : -1;
    }
    if (a[property] < b[property]) {
        return dir === 'asc' ? -1 : 1;
    }
    return 0;
}

export function getActualTrendColor(
    actualTrend: number,
    rankOrder: boolean,
): string {
    const classDanger = 'sc-text-danger';
    const classSuccess = 'sc-text-success';

    if (actualTrend === null) {
        return null;
    }
    let actualTrendColor = 'sc-text-neutral';
    if (actualTrend < 0) {
        actualTrendColor = rankOrder ? classDanger : classSuccess;
    } else if (actualTrend > 0) {
        actualTrendColor = rankOrder ? classSuccess : classDanger;
    }
    return actualTrendColor;
}
